<template>
  <div class="modal fade create-mail-subscription-modal" tabindex="-1" role="dialog" :data-person-id="person.id">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Mail Subscription
            </h4>
          </div>

          <LoadingSpinner v-if="loading"/>

          <div v-else class="modal-body">
            <SelectFormGroup
                v-model="data.list_id"
                name="list_id"
                label="Mailing List"
                :error="getError('list_id')"
                :options="externalMailingListOptions"
            />

            <SelectFormGroup
                v-model="data.frequency"
                name="frequency"
                label="Frequency"
                :error="getError('frequency')"
                :options="frequencyOptions"
            />

            <pre>Foo</pre>
            <pre>
              {{ externalMailingListInterests }}
            </pre>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {LoadingSpinner, SelectFormGroup},

  mixins: [Errors],

  props: ['person'],

  data() {
    return {
      data: {
        frequency: 'high'
      },

      externalMailingLists: null,
      externalMailingListInterests: null,

      loading: true
    }
  },

  mounted() {
    this.listenForClose()

    http.get('/api/v2/external/mailing-lists').then(response => {
      this.externalMailingLists = response.data.data

      this.loading = false
    })
  },

  watch: {
    'data.list_id'() {
      this.getInterests()
    }
  },

  computed: {
    externalMailingListOptions() {
      return this.externalMailingLists.map(externalMailingList => {
        return {
          value: externalMailingList.id,
          label: externalMailingList.attributes.name
        }
      })
    },

    frequencyOptions() {
      return [
        {value: 'low', label: 'Lav'},
        {value: 'medium', label: 'Mellem'},
        {value: 'high', label: 'Høj'}
      ]
    }
  },

  methods: {
    listenForClose() {
      $('.create-mail-subscription-modal[data-person-id='+this.person.id+']').on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/external/mail-subscriptions', {
        ...this.data,
        name: this.person.attributes.name,
        email: this.person.attributes.email,
      })
          .then(response => {
            notify.success('The person was subscribed to the mailing list')

            this.$emit('created', response.data.data)

            $('.create-mail-subscription-modal[data-person-id='+this.person.id+']').modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    getInterests() {
      http.get('/api/v2/external/mailing-lists/' + this.data.list_id +'/interests').then(response => {
        this.externalMailingListInterests = response.data.data
      })
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
